// Eskom PARCC — on/off switch, in two shapes.
//
// Legacy renders the native checkbox it has always used (so the Notifications
// screen is unchanged); Lumen renders the handoff's pill. Same accessible name,
// same checked state, same onChange — the control is one thing with two looks.
import { useVariant } from '../../lib/uiPrefs';

export function Switch({
  checked,
  onChange,
  ariaLabel,
  disabled = false,
  title,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  /** Accessible name. Required: neither shape has visible text of its own. */
  ariaLabel: string;
  disabled?: boolean;
  title?: string;
}): React.JSX.Element {
  const variant = useVariant();

  if (variant === 'lumen') {
    return (
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={ariaLabel}
        title={title}
        disabled={disabled}
        className="lm-switch"
        onClick={() => onChange(!checked)}
      />
    );
  }

  return (
    <input
      type="checkbox"
      checked={checked}
      disabled={disabled}
      aria-label={ariaLabel}
      title={title}
      onChange={(e) => onChange(e.target.checked)}
    />
  );
}
